<div class="dashboard-container container-fluid px-0">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <MiningSidebar
        v-if="sidebar_sector === 'mining'"
        :active_item="sidebar_mining_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @go-overview="open_sidebar_portfolio"
        @mining-menu-selected="open_sidebar_mining_menu"
        @select-sector="open_sidebar_sector"
      />
      <PropertySidebar
        v-else-if="sidebar_active_property"
        :active_property="sidebar_active_property"
        :properties="sidebar_tiles"
        :active_item="sidebar_active_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @switch-property="open_sidebar_property"
        @go-back="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @select-sector="open_sidebar_sector"
      />
      <PortfolioSidebar
        v-else
        :tiles="sidebar_tiles"
        @tile-clicked="open_sidebar_property"
        @global-menu-selected="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @global-selected="open_sidebar_portfolio"
        @select-sector="open_sidebar_sector"
      />
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="mobile_sidebar_open = false">
      <div class="mobile-sidebar-panel h-100 overflow-hidden">
        <MiningSidebar
          v-if="sidebar_sector === 'mining'"
          :active_item="sidebar_mining_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @go-overview="open_sidebar_portfolio"
          @mining-menu-selected="open_sidebar_mining_menu"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </MiningSidebar>
        <PropertySidebar
          v-else-if="sidebar_active_property"
          :active_property="sidebar_active_property"
          :properties="sidebar_tiles"
          :active_item="sidebar_active_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @switch-property="open_sidebar_property"
          @go-back="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PropertySidebar>
        <PortfolioSidebar
          v-else
          :tiles="sidebar_tiles"
          @tile-clicked="open_sidebar_property"
          @global-menu-selected="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @global-selected="open_sidebar_portfolio"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="sidebar_collapsed = !sidebar_collapsed" aria-label="Toggle sidebar">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="show_assistant = true"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
    />

<div class="container-fluid p-0 settings-page user-management-page flex-grow-1 min-h-0 bg-danger bg-opacity-10">
    <section class="container-fluid px-4 py-4">
        <SettingsUserManagementTab :user_profile="user_profile" />
    </section>

    <BolideAssistant :is_open="show_assistant" @close-assistant="show_assistant = false" />
</div>
    </div>
  </div>
</div>
